export default {
  path: '/about',
  component: () => import('@/components/views/About')
}
